import { render, staticRenderFns } from "./Scales.vue?vue&type=template&id=76829ff4&scoped=true"
import script from "./Scales.vue?vue&type=script&lang=ts"
export * from "./Scales.vue?vue&type=script&lang=ts"
import style0 from "./Scales.vue?vue&type=style&index=0&id=76829ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76829ff4",
  null
  
)

export default component.exports